<span [class]="'display-flex flex-align-center badge-status badge-status-' + status"
      [matTooltip]="tooltipMessage"
      [matTooltipDisabled]="!tooltipActivated"
      matTooltipPosition="above">
  <span class="badge-dot"></span>
  <span class="badge-text">
    {{'export.status.'+status | translate}}
  </span>
  <span class="badge-question-mark ml-5" *ngIf="tooltipActivated">
    <mat-icon [inline]="true">help</mat-icon>
  </span>
</span>
